<template>
  <!-- <router-view /> -->
  <div class="home">
    <img src="@/assets/1.jpg" alt="" />
    <img src="@/assets/2.jpg" alt="" />
    <img src="@/assets/3.jpg" alt="" />
    <img src="@/assets/4.jpg" alt="" />
    <img src="@/assets/5.jpg" alt="" />
    <div class="footer">
      <span
        >Copyright © 2024-2025 Metaverse Space.All Rights Reserved
        <a href="https://beian.miit.gov.cn/">
          备案号：闽ICP备2025085067号-1
        </a></span
      >
    </div>
  </div>
</template>
<script setup>
import { onMounted, onUnmounted } from "vue";

onMounted(() => {
  document.title = "摩罗（厦门）科技有限公司";
});

onUnmounted(() => {
  document.title = "摩罗（厦门）科技有限公司";
});
</script>
<style>
html,
body,
#app {
  margin: 0;

  padding: 0;
  height: 100%;
  /* height: 100%; */
  font-family: Yuanti;
}
html {
  font-size: 100px;
}

.home {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}
img {
  width: 100%;
  height: auto;
}
.footer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0.12rem;
}
span {
  font-size: 0.2rem;
  color: #fff;
}
a {
  text-decoration: none;
  color: #fff;
}
</style>
